var React = require('react');

function DownChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 2L12.1321 12L21 2","stroke":"#6677FB","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round"}));
}

DownChevron.defaultProps = {"width":"23","height":"14","viewBox":"0 0 23 14","fill":"none"};

module.exports = DownChevron;

DownChevron.default = DownChevron;
